/**
 * A string constant representing the common icon used for payment methods.
 */
const COMMON_ICON = 'COMMON_ICON';

/**
 * A string template used to construct the path for payment method icons.
 */
const ASSETS_PATH = `${process.env.PUBLIC_URL}/assets/%s.png`;

/**
 * A string template used to format payment details, including the payment type and expiration date.
 *
 * The placeholders in the template are:
 * - `%s` (1st): The payment type (e.g., Visa, MasterCard, etc.).
 * - `%s` (2nd): The expiration month in two-digit format (e.g., "12").
 * - `%s` (3rd): The expiration year in two-digit format (e.g., "25").
 */
const PAYMENT_DETAILS_FORMAT = '%s Expires %s / %s';

/**
 * Template for payment submit button label with amount placeholder.
 * Use %s for amount formatting.
 */
const PAYMENT_SUBMIT_BUTTON_LABEL = 'Pay Now: $%s';

/**
 * Button labels for payment actions.
 */
const PAYMENT_DRAWER_BUTTON_LABEL = 'Use this card';
const PAYMENT_DEFAULT_BUTTON_LABEL = 'Make Default';
const PAYMENT_DELETE_BUTTON_LABEL = 'Delete';

export {
  ASSETS_PATH,
  COMMON_ICON,
  PAYMENT_DEFAULT_BUTTON_LABEL,
  PAYMENT_DELETE_BUTTON_LABEL,
  PAYMENT_DETAILS_FORMAT,
  PAYMENT_DRAWER_BUTTON_LABEL,
  PAYMENT_SUBMIT_BUTTON_LABEL,
};
